export enum TraceableProcess {
  AUTOPUBLISH = 'Autopublish',
  APPLICATION = 'Application',
  APPOINTMENT_SCHEDULING = 'Appointment Scheduling',
  NAVIGATION = 'Navigation',
  USER_PROFILE = 'User profile',
  PRICE_CALCULATOR = 'Price calculator',
  LANDLORD_LANDING = 'Landlord landing',
  LANDLORD_DASHBOARD = 'Landlord Dashboard',
  LANDING_RECOMMENDATION = 'Landing Recommendation',
  PAYMENTS = 'Payments',
  EXPERIMENTS = 'Experiments',
  GOOGLE_MAPS = 'Google Maps',
  LISTING_DETAILS = 'Listing Details',
  LEASE_CALCULATOR = 'Lease Calculator',
  AGREEMENTS = 'Agreements',
}

export interface Tag {
  key: string;
  value: string;
}

export interface TrackingEvent {
  action: string;
  category: TraceableProcess;
  label?: string;
  tags?: Tag[];
}

export interface TrackingEventExtended extends TrackingEvent {
  [x: string]: unknown;
}

export interface TrackingIdentity {
  userId: string;
  userData?: Record<string, unknown>;
}

export interface TrackingPage {
  category: string | undefined;
  name: string | undefined;
}

export interface Tracker {
  trackEvent(event: TrackingEvent | TrackingEventExtended): Promise<void>;

  trackIdentity(event: TrackingIdentity): Promise<void>;

  trackPage(page?: TrackingPage): Promise<void>;
}
